import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAggregateDataQueryVariables = Types.Exact<{
  rootAssetId: Types.Scalars['ID']['input'];
  query: Types.AggregateDataQueryInput;
}>;


export type GetAggregateDataQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, aggregateData?: { __typename?: 'AggregateData', totalCount?: number | null, totalFileSize?: number | null, totalDuration?: number | null } | null } | null };


export const GetAggregateData = /*#__PURE__*/ gql`
    query GetAggregateData($rootAssetId: ID!, $query: AggregateDataQueryInput!) {
  account(by: {assetId: $rootAssetId}) {
    id
    aggregateData(query: $query) {
      totalCount
      totalFileSize
      totalDuration
    }
  }
}
    ` as unknown as DocumentNode<GetAggregateDataQuery, GetAggregateDataQueryVariables>;

          

          export const useGetAggregateDataQuery = (options?:QueryHookOptions<GetAggregateDataQuery, GetAggregateDataQueryVariables>) => useQuery(GetAggregateData, options);

          

          export type GetAggregateDataQueryOptions = QueryHookOptions<GetAggregateDataQuery, GetAggregateDataQueryVariables>;

          

          export const useGetAggregateDataLazyQuery = (options?:LazyQueryHookOptions<GetAggregateDataQuery, GetAggregateDataQueryVariables>) => useLazyQuery(GetAggregateData, options);

          

          export type GetAggregateDataQueryResult = ReturnType<typeof useGetAggregateDataQuery>;

          
